module.exports = __webpack_public_path__ + "img/iDays_logo.e5659d24.png";